<ion-item>
    <ion-grid>
        <ion-row>
            <ion-col> <!-- Mejorar interfaz -->
                <div class = "circle-div" [class.selected] = "selected"></div>
            </ion-col>
            <ion-col>
                <img [src]="member.photo" style="width: 100%; border-radius: 4px;"/>
            </ion-col>
            <ion-col>
                {{ memberName }}
            </ion-col>
        </ion-row>
    </ion-grid>    
</ion-item>